import { styled } from '@mui/system';

export const Main = styled('main')(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(2),
  paddingTop: theme.spacing(3),
  overflow: 'auto',
  height: '100%',
  position: 'relative',
  WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
  marginBottom: '50px',
}));

export const AppBarOffset = styled('div')(({ theme }) => theme.mixins.toolbar);